export const API_BASE = import.meta.env.VITE_APP_BASE_URL
export const WS_BASE =
  import.meta.env.VITE_WS_URL ??
  `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws`

export const ROLES = {
  ADMIN: 'administrator',
  PARTICIPANT: 'participant',
  REPRESENTATIVE: 'representative',
} as const

export type UserRole = (typeof ROLES)[keyof typeof ROLES]
export type RegularRole = Exclude<UserRole, typeof ROLES.ADMIN>
